import cn from 'clsx'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { ResultsFilteredByDestination } from './ResultsFilteredByDestination'
import { ResultsFilteredByHolidayType } from './ResultsFilteredByHolidayType'
import { ResultsFilteredByHolidayTypeAndDestination } from './ResultsFilteredByHolidayTypeAndDestination'
import { UnfilteredResults } from './UnfilteredResults'

const HeadingSection = styled.div`
  padding-top: ${rem(100)};
  padding-bottom: ${rem(100)};
`

interface Props {
  showResultsFilteredByHolidayTypeAndDestination?: boolean
  showResultsFilteredByHolidayType?: boolean
  showResultsFilteredByDestination?: boolean
  showUnfilteredResults?: boolean
  holidayType: string
  destination: string
  hasImage?: boolean
}

function HolidayTypeLandingPageHeroHeading({
  showResultsFilteredByHolidayTypeAndDestination = false,
  showResultsFilteredByHolidayType = false,
  showResultsFilteredByDestination = false,
  showUnfilteredResults,
  holidayType,
  destination,
  hasImage = false,
}: Props) {
  return <HeadingSection className={cn({ 'has-image': hasImage })}>
    {showResultsFilteredByHolidayTypeAndDestination &&
      <ResultsFilteredByHolidayTypeAndDestination
        holidayType={holidayType}
        destination={destination}
        hasImage={hasImage}
      />}
    {showResultsFilteredByHolidayType && <ResultsFilteredByHolidayType holidayType={holidayType} hasImage={hasImage} />}
    {showResultsFilteredByDestination && <ResultsFilteredByDestination destination={destination} hasImage={hasImage} />}
    {showUnfilteredResults && <UnfilteredResults />}
  </HeadingSection>
}
export default HolidayTypeLandingPageHeroHeading
